import { createSelector } from '@reduxjs/toolkit';
import { isAvailableRegion, MOSCOW_ID } from '../../../../packages/JsonQuery';
import { selectIsDemolished, selectJsonQuery } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Не показывать', value: false },
  { label: 'Только под снос', value: true },
];

export const selectDemolitionFilter = createSelector([selectIsDemolished, selectJsonQuery], (value, jsonQuery) => ({
  label: 'Дома под снос',
  value: [value],
  options: OPTIONS,
  visible: isAvailableRegion([MOSCOW_ID])(jsonQuery),
}));
